import { render, staticRenderFns } from "./ReporteGerencia.vue?vue&type=template&id=870accac&scoped=true&"
import script from "./ReporteGerencia.vue?vue&type=script&lang=js&"
export * from "./ReporteGerencia.vue?vue&type=script&lang=js&"
import style0 from "./ReporteGerencia.vue?vue&type=style&index=0&id=870accac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870accac",
  null
  
)

export default component.exports